import { useQuery } from "react-query";
import { getAllSalesforce } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetAllSalesforce = () => {
  return useQuery("GetAllSalesforce", getAllSalesforce, {
    refetchOnWindowFocus: false,
  });
};
export default useGetAllSalesforce;
